function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Support-Panel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Toast/-1-Action-Copy",
  transform: "translate(-459.000000, -22.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("g", {
  id: "Components/Close/White",
  transform: "translate(453.000000, 16.000000)"
}, React.createElement("path", {
  d: "M13.1171376,5.6698065 L13.1171376,11.1698065 L18.6171376,11.1698065 L18.6171376,13.1698065 L13.1171376,13.1698065 L13.1171376,18.6698065 L11.1171376,18.6698065 L11.1171376,13.1698065 L5.6171376,13.1698065 L5.6171376,11.1698065 L11.1171376,11.1698065 L11.1171376,5.6698065 L13.1171376,5.6698065 Z",
  id: "Combined-Shape",
  transform: "translate(12.117138, 12.169807) rotate(45.000000) translate(-12.117138, -12.169807) "
})))));

var SvgCloseWhite = function SvgCloseWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-white.05dfea53.svg";
export { ForwardRef as ReactComponent };